/* tslint:disable */
/* eslint-disable */
/**
 * Graphne
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.64.0-5-56163b67
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AutoPlanRequest,
  AutoPlanRequestDependencies,
  CancelToDoTasksView,
  DependenciesGraph,
  ErrorDetails,
  ForbiddenError,
  FreezingBoundarySaveView,
  GanttUpdate,
  GetGroupDetailsFilter,
  KanbanUpdate,
  PlanningBoundarySaveView,
  PlanningWindowView,
  ProductionOrderPriorityUpdate,
  ProductionParameterName,
  ProductionPlanBatchEntryView,
  ProductionPlanEntry,
  Queue,
  QueueDurationForecast,
  QueueProperties,
  ResourceAvailabilityMeta,
  ResourceGroup,
  ResourceGroupTimeframeDetailsView,
  RetoolingMatrixDetailsView,
  RetoolingMatrixEntriesUpdate,
  RetoolingMatrixListRequest,
  RetoolingMatrixListResult,
  RetoolingMatrixMetadata,
  ShortObjectView,
  SimulationApplyView,
  SimulationApplyingStatus,
  SimulationCancelTasksView,
  SimulationCreateOptimizeView,
  SimulationFilterDefinition,
  SimulationGetTasksFilterSortBy,
  SimulationListResult,
  SimulationMetadataSaveView,
  SimulationMetadataView,
  SimulationParameterView,
  SimulationTaskUpdateAmountView,
  SimulationTaskUpdateRecipeVersionName,
  SimulationTaskUpdateTechnologyView,
  SimulationTasksUpdates,
  SimulationValidationResultView,
  SoftResourceAreaUnassignmentRequest,
  SoftResourceAreaUnassignmentResultView,
  SoftResourceAssignment,
  SoftResourceAssignmentV2,
  SoftResourceBatchAssignment,
  SoftResourceBatchAssignmentV2,
  SoftResourcesAssignmentFilter,
  SortOrder,
  Task,
  TaskAddEntry,
  TaskAvailableQueues,
  TaskFilterDefinition,
  TaskIngredientsView,
  TaskView,
  ToDoListView,
  ToDoTrees,
  UnauthorizedError,
} from '../models';

export interface DeleteGraphneProductionPlanEntriesTaskidRequest {
    taskId: string;
}

export interface GetGraphneGanttFullRequest {
    simulationId?: string;
}

export interface GetGraphneGanttPlanningWindowRequest {
    simulationId?: string;
}

export interface GetGraphneGanttSseSchemaRequest {
    from: string;
    to: string;
    queues?: Array<string>;
    withDependenciesDetails?: boolean;
    lotNumbers?: Array<string>;
    isBehindSchedule?: boolean;
    requiresAcceptance?: boolean;
    priority?: boolean;
    onlyQueuesWithTasks?: boolean;
}

export interface GetGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationidRequest {
    simulationId: string;
    from: string;
    to: string;
    queues?: Array<string>;
    withDependenciesDetails?: boolean;
    lotNumbers?: Array<string>;
    isBehindSchedule?: boolean;
    requiresAcceptance?: boolean;
    priority?: boolean;
    onlyQueuesWithTasks?: boolean;
}

export interface GetGraphneGanttUpdatesRequest {
    from: string;
    to: string;
    queues?: Array<string>;
    withDependenciesDetails?: boolean;
    lotNumbers?: Array<string>;
    isBehindSchedule?: boolean;
    requiresAcceptance?: boolean;
    priority?: boolean;
    onlyQueuesWithTasks?: boolean;
}

export interface GetGraphneGraphTaskidRequest {
    taskId: string;
}

export interface GetGraphneInternalRetoolingMatrixIdDetailsRequest {
    id: string;
    sortOrder?: SortOrder;
}

export interface GetGraphneKanbanSseSchemaRequest {
    from?: string;
    to?: string;
    queues?: Array<string>;
    lotNumbers?: Array<string>;
    isBehindSchedule?: boolean;
    requiresAcceptance?: boolean;
    priority?: boolean;
    onlyQueuesWithTasks?: boolean;
}

export interface GetGraphneKanbanUpdatesRequest {
    from?: string;
    to?: string;
    queues?: Array<string>;
    lotNumbers?: Array<string>;
    isBehindSchedule?: boolean;
    requiresAcceptance?: boolean;
    priority?: boolean;
    onlyQueuesWithTasks?: boolean;
}

export interface GetGraphneProductionPlanAutoplanDependenciesRequest {
    ids?: Array<string>;
}

export interface GetGraphneQueuesQueueidRequest {
    queueId: string;
}

export interface GetGraphneResourcesSoftPossibleTasksResourceidRequest {
    resourceId: string;
    start?: string;
    end?: string;
}

export interface GetGraphneSimulationSimulationidGanttUpdatesRequest {
    simulationId: string;
    from: string;
    to: string;
    queues?: Array<string>;
    withDependenciesDetails?: boolean;
    lotNumbers?: Array<string>;
    isBehindSchedule?: boolean;
    requiresAcceptance?: boolean;
    priority?: boolean;
    onlyQueuesWithTasks?: boolean;
}

export interface GetGraphneSimulationSimulationidMetadataRequest {
    simulationId: string;
}

export interface GetGraphneSimulationSimulationidTasksRequest {
    simulationId: string;
    page: number;
    pageSize: number;
    queueId?: string;
    queueAreaId?: string;
    search?: string;
    productionStartFromDateTime?: string;
    productionStartToDateTime?: string;
    queueIds?: Array<string>;
    queueAreaIds?: Array<string>;
    sortBy?: SimulationGetTasksFilterSortBy;
    sortOrder?: SortOrder;
}

export interface GetGraphneSimulationSimulationidTasksP1RecipesversionnamesRequest {
    simulationId: string;
    p1: string;
}

export interface GetGraphneSimulationTasksP1MergecandidatesRequest {
    p1: string;
}

export interface GetGraphneTasksTaskidRequest {
    taskId: string;
}

export interface GetGraphneTasksTaskidAvailableQueuesRequest {
    taskId: string;
}

export interface GetGraphneTasksTaskidDurationForecastRequest {
    taskId: string;
    queueId: string;
    start: string;
}

export interface GetGraphneTasksTaskidIngredientsRequest {
    taskId: string;
}

export interface GetGraphneTasksTaskidQueueDurationForecastRequest {
    taskId: string;
    queueId: string;
    start: string;
}

export interface PatchGraphneQueuesQueueidPropertiesRequest {
    queueId: string;
    queueProperties: QueueProperties;
}

export interface PostGraphneInternalRetoolingMatrixListRequest {
    retoolingMatrixListRequest: RetoolingMatrixListRequest;
}

export interface PostGraphneProductionPlanAutoplanRequest {
    requestBody?: Array<number>;
}

export interface PostGraphneProductionPlanAutoplanPullPlaningRequest {
    autoPlanRequest: AutoPlanRequest;
}

export interface PostGraphneProductionPlanEntriesRequest {
    taskAddEntry: TaskAddEntry;
}

export interface PostGraphneProductionPlanEntriesBatchMoveRequest {
    productionPlanBatchEntryView: ProductionPlanBatchEntryView;
}

export interface PostGraphneProductionPlanEntriesMoveRequest {
    productionPlanEntry: ProductionPlanEntry;
}

export interface PostGraphneQueuesRequest {
    queue: Queue;
}

export interface PostGraphneResourcesGroupTimeframeResourcegroupidRequest {
    resourceGroupId: string;
    getGroupDetailsFilter: GetGroupDetailsFilter;
}

export interface PostGraphneResourcesSoftAssignRequest {
    softResourceAssignment?: Array<SoftResourceAssignment>;
}

export interface PostGraphneResourcesSoftAssignBatchRequest {
    softResourceBatchAssignment?: Array<SoftResourceBatchAssignment>;
}

export interface PostGraphneResourcesSoftAssignWithoutValidationRequest {
    softResourceAssignment?: Array<SoftResourceAssignment>;
}

export interface PostGraphneResourcesSoftAssignWithoutValidationBatchRequest {
    softResourceBatchAssignment?: Array<SoftResourceBatchAssignment>;
}

export interface PostGraphneResourcesSoftAssignmentBatchBatchidRequest {
    batchId: string;
    softResourcesAssignmentFilter: SoftResourcesAssignmentFilter;
}

export interface PostGraphneResourcesSoftAssignmentTaskidRequest {
    taskId: string;
    softResourcesAssignmentFilter: SoftResourcesAssignmentFilter;
}

export interface PostGraphneResourcesSoftUnassignRequest {
    softResourceAssignment?: Array<SoftResourceAssignment>;
}

export interface PostGraphneResourcesSoftUnassignAllRequest {
    softResourceAreaUnassignmentRequest: SoftResourceAreaUnassignmentRequest;
}

export interface PostGraphneResourcesSoftUnassignBatchRequest {
    softResourceBatchAssignment?: Array<SoftResourceBatchAssignment>;
}

export interface PostGraphneResourcesSoftUnassignUnavailableRequest {
    softResourceAreaUnassignmentRequest: SoftResourceAreaUnassignmentRequest;
}

export interface PostGraphneResourcesSoftV2AssignRequest {
    softResourceAssignmentV2: SoftResourceAssignmentV2;
}

export interface PostGraphneResourcesSoftV2AssignBatchRequest {
    softResourceBatchAssignmentV2: SoftResourceBatchAssignmentV2;
}

export interface PostGraphneSimulationApplyRequest {
    simulationApplyView: SimulationApplyView;
}

export interface PostGraphneSimulationCreateRequest {
    simulationCreateOptimizeView: SimulationCreateOptimizeView;
}

export interface PostGraphneSimulationListRequest {
    simulationFilterDefinition: SimulationFilterDefinition;
}

export interface PostGraphneSimulationMetadataSaveRequest {
    simulationMetadataSaveView: SimulationMetadataSaveView;
}

export interface PostGraphneSimulationMetadataSaveFreezingBoundaryRequest {
    freezingBoundarySaveView: FreezingBoundarySaveView;
}

export interface PostGraphneSimulationMetadataSavePlanningBoundaryRequest {
    planningBoundarySaveView: PlanningBoundarySaveView;
}

export interface PostGraphneSimulationSimulationidAutoplanRequest {
    simulationId: string;
    autoPlanRequest: AutoPlanRequest;
}

export interface PostGraphneSimulationSimulationidBatchesP1FreezeRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidBatchesP1MarkToPublishRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidBatchesP1UnfreezeRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidBatchesP1UnmarkToPublishRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidOptimizeRequest {
    simulationId: string;
    simulationCreateOptimizeView: SimulationCreateOptimizeView;
}

export interface PostGraphneSimulationSimulationidTasksCancelRequest {
    simulationId: string;
    simulationCancelTasksView: SimulationCancelTasksView;
}

export interface PostGraphneSimulationSimulationidTasksP1AmountRequest {
    simulationId: string;
    p1: string;
    simulationTaskUpdateAmountView: SimulationTaskUpdateAmountView;
}

export interface PostGraphneSimulationSimulationidTasksP1FreezeRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidTasksP1MarkToPublishRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidTasksP1RecipeversionnameRequest {
    simulationId: string;
    p1: string;
    simulationTaskUpdateRecipeVersionName: SimulationTaskUpdateRecipeVersionName;
}

export interface PostGraphneSimulationSimulationidTasksP1TechnologyRequest {
    simulationId: string;
    p1: string;
    simulationTaskUpdateTechnologyView: SimulationTaskUpdateTechnologyView;
}

export interface PostGraphneSimulationSimulationidTasksP1UnfreezeRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidTasksP1UnmarkToPublishRequest {
    simulationId: string;
    p1: string;
}

export interface PostGraphneSimulationSimulationidTasksUpdateRequest {
    simulationId: string;
    simulationTasksUpdates: SimulationTasksUpdates;
}

export interface PostGraphneSimulationSimulationidValidateRequest {
    simulationId: string;
    simulationCreateOptimizeView: SimulationCreateOptimizeView;
}

export interface PostGraphneTodoListRequest {
    taskFilterDefinition: TaskFilterDefinition;
}

export interface PostGraphneTodoTasksCancelRequest {
    cancelToDoTasksView: CancelToDoTasksView;
}

export interface PostGraphneTodoTreeRequest {
    taskFilterDefinition: TaskFilterDefinition;
}

export interface PutGraphneInternalRetoolingMatrixMetadataRetoolingmatrixidRequest {
    retoolingMatrixId: string;
    retoolingMatrixMetadata: RetoolingMatrixMetadata;
}

export interface PutGraphneInternalRetoolingMatrixRetoolingmatrixidEntriesRequest {
    retoolingMatrixId: string;
    retoolingMatrixEntriesUpdate: RetoolingMatrixEntriesUpdate;
}

export interface PutGraphneProductionOrdersTasksTaskidPriorityRequest {
    taskId: string;
    productionOrderPriorityUpdate: ProductionOrderPriorityUpdate;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Delete entry from plan by TaskId
     */
    async deleteGraphneProductionPlanEntriesTaskidRaw(requestParameters: DeleteGraphneProductionPlanEntriesTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling deleteGraphneProductionPlanEntriesTaskid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan-entries/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete entry from plan by TaskId
     */
    async deleteGraphneProductionPlanEntriesTaskid(requestParameters: DeleteGraphneProductionPlanEntriesTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteGraphneProductionPlanEntriesTaskidRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getGraphneGanttFullRaw(requestParameters: GetGraphneGanttFullRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GanttUpdate>> {
        const queryParameters: any = {};

        if (requestParameters.simulationId !== undefined) {
            queryParameters['simulationId'] = requestParameters.simulationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/gantt/full`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGraphneGanttFull(requestParameters: GetGraphneGanttFullRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GanttUpdate> {
        const response = await this.getGraphneGanttFullRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the GANTT planning window from the beginning of the last week to the end of the current week
     */
    async getGraphneGanttPlanningWindowRaw(requestParameters: GetGraphneGanttPlanningWindowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanningWindowView>> {
        const queryParameters: any = {};

        if (requestParameters.simulationId !== undefined) {
            queryParameters['simulationId'] = requestParameters.simulationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/gantt/planning/window`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns the GANTT planning window from the beginning of the last week to the end of the current week
     */
    async getGraphneGanttPlanningWindow(requestParameters: GetGraphneGanttPlanningWindowRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanningWindowView> {
        const response = await this.getGraphneGanttPlanningWindowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schema for gantt updates SSE events
     */
    async getGraphneGanttSseSchemaRaw(requestParameters: GetGraphneGanttSseSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GanttUpdate>> {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getGraphneGanttSseSchema.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getGraphneGanttSseSchema.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.queues) {
            queryParameters['queues'] = requestParameters.queues;
        }

        if (requestParameters.withDependenciesDetails !== undefined) {
            queryParameters['withDependenciesDetails'] = requestParameters.withDependenciesDetails;
        }

        if (requestParameters.lotNumbers) {
            queryParameters['lotNumbers'] = requestParameters.lotNumbers;
        }

        if (requestParameters.isBehindSchedule !== undefined) {
            queryParameters['isBehindSchedule'] = requestParameters.isBehindSchedule;
        }

        if (requestParameters.requiresAcceptance !== undefined) {
            queryParameters['requiresAcceptance'] = requestParameters.requiresAcceptance;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['priority'] = requestParameters.priority;
        }

        if (requestParameters.onlyQueuesWithTasks !== undefined) {
            queryParameters['onlyQueuesWithTasks'] = requestParameters.onlyQueuesWithTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/gantt-sse-schema`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Schema for gantt updates SSE events
     */
    async getGraphneGanttSseSchema(requestParameters: GetGraphneGanttSseSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GanttUpdate> {
        const response = await this.getGraphneGanttSseSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schema for simulation gantt updates SSE events
     */
    async getGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationidRaw(requestParameters: GetGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GanttUpdate>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling getGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationid.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationid.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationid.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.queues) {
            queryParameters['queues'] = requestParameters.queues;
        }

        if (requestParameters.withDependenciesDetails !== undefined) {
            queryParameters['withDependenciesDetails'] = requestParameters.withDependenciesDetails;
        }

        if (requestParameters.lotNumbers) {
            queryParameters['lotNumbers'] = requestParameters.lotNumbers;
        }

        if (requestParameters.isBehindSchedule !== undefined) {
            queryParameters['isBehindSchedule'] = requestParameters.isBehindSchedule;
        }

        if (requestParameters.requiresAcceptance !== undefined) {
            queryParameters['requiresAcceptance'] = requestParameters.requiresAcceptance;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['priority'] = requestParameters.priority;
        }

        if (requestParameters.onlyQueuesWithTasks !== undefined) {
            queryParameters['onlyQueuesWithTasks'] = requestParameters.onlyQueuesWithTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/gantt-sse-schema/simulation-gantt-sse-schema/{simulationId}`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Schema for simulation gantt updates SSE events
     */
    async getGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationid(requestParameters: GetGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GanttUpdate> {
        const response = await this.getGraphneGanttSseSchemaSimulationGanttSseSchemaSimulationidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneGanttUpdatesRaw(requestParameters: GetGraphneGanttUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getGraphneGanttUpdates.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getGraphneGanttUpdates.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.queues) {
            queryParameters['queues'] = requestParameters.queues;
        }

        if (requestParameters.withDependenciesDetails !== undefined) {
            queryParameters['withDependenciesDetails'] = requestParameters.withDependenciesDetails;
        }

        if (requestParameters.lotNumbers) {
            queryParameters['lotNumbers'] = requestParameters.lotNumbers;
        }

        if (requestParameters.isBehindSchedule !== undefined) {
            queryParameters['isBehindSchedule'] = requestParameters.isBehindSchedule;
        }

        if (requestParameters.requiresAcceptance !== undefined) {
            queryParameters['requiresAcceptance'] = requestParameters.requiresAcceptance;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['priority'] = requestParameters.priority;
        }

        if (requestParameters.onlyQueuesWithTasks !== undefined) {
            queryParameters['onlyQueuesWithTasks'] = requestParameters.onlyQueuesWithTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/gantt/updates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getGraphneGanttUpdates(requestParameters: GetGraphneGanttUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getGraphneGanttUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dependencies graph
     */
    async getGraphneGraphTaskidRaw(requestParameters: GetGraphneGraphTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DependenciesGraph>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getGraphneGraphTaskid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/graph/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Dependencies graph
     */
    async getGraphneGraphTaskid(requestParameters: GetGraphneGraphTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DependenciesGraph> {
        const response = await this.getGraphneGraphTaskidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the production parameter dictionary (id -> name)
     */
    async getGraphneInternalProductionParametersDictionaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductionParameterName>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/internal/production-parameters/dictionary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns the production parameter dictionary (id -> name)
     */
    async getGraphneInternalProductionParametersDictionary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductionParameterName>> {
        const response = await this.getGraphneInternalProductionParametersDictionaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the details of a single retooling matrix
     */
    async getGraphneInternalRetoolingMatrixIdDetailsRaw(requestParameters: GetGraphneInternalRetoolingMatrixIdDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetoolingMatrixDetailsView>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getGraphneInternalRetoolingMatrixIdDetails.');
        }

        const queryParameters: any = {};

        if (requestParameters.sortOrder !== undefined) {
            queryParameters['sortOrder'] = requestParameters.sortOrder;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/internal/retooling-matrix/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns the details of a single retooling matrix
     */
    async getGraphneInternalRetoolingMatrixIdDetails(requestParameters: GetGraphneInternalRetoolingMatrixIdDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetoolingMatrixDetailsView> {
        const response = await this.getGraphneInternalRetoolingMatrixIdDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Schema for kanban updates SSE events
     */
    async getGraphneKanbanSseSchemaRaw(requestParameters: GetGraphneKanbanSseSchemaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KanbanUpdate>> {
        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.queues) {
            queryParameters['queues'] = requestParameters.queues;
        }

        if (requestParameters.lotNumbers) {
            queryParameters['lotNumbers'] = requestParameters.lotNumbers;
        }

        if (requestParameters.isBehindSchedule !== undefined) {
            queryParameters['isBehindSchedule'] = requestParameters.isBehindSchedule;
        }

        if (requestParameters.requiresAcceptance !== undefined) {
            queryParameters['requiresAcceptance'] = requestParameters.requiresAcceptance;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['priority'] = requestParameters.priority;
        }

        if (requestParameters.onlyQueuesWithTasks !== undefined) {
            queryParameters['onlyQueuesWithTasks'] = requestParameters.onlyQueuesWithTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/kanban-sse-schema`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Schema for kanban updates SSE events
     */
    async getGraphneKanbanSseSchema(requestParameters: GetGraphneKanbanSseSchemaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KanbanUpdate> {
        const response = await this.getGraphneKanbanSseSchemaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneKanbanUpdatesRaw(requestParameters: GetGraphneKanbanUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.queues) {
            queryParameters['queues'] = requestParameters.queues;
        }

        if (requestParameters.lotNumbers) {
            queryParameters['lotNumbers'] = requestParameters.lotNumbers;
        }

        if (requestParameters.isBehindSchedule !== undefined) {
            queryParameters['isBehindSchedule'] = requestParameters.isBehindSchedule;
        }

        if (requestParameters.requiresAcceptance !== undefined) {
            queryParameters['requiresAcceptance'] = requestParameters.requiresAcceptance;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['priority'] = requestParameters.priority;
        }

        if (requestParameters.onlyQueuesWithTasks !== undefined) {
            queryParameters['onlyQueuesWithTasks'] = requestParameters.onlyQueuesWithTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/kanban/updates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getGraphneKanbanUpdates(requestParameters: GetGraphneKanbanUpdatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getGraphneKanbanUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneProductionPlanRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProductionPlanEntry>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGraphneProductionPlan(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProductionPlanEntry>> {
        const response = await this.getGraphneProductionPlanRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneProductionPlanAutoplanDependenciesRaw(requestParameters: GetGraphneProductionPlanAutoplanDependenciesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutoPlanRequestDependencies>> {
        const queryParameters: any = {};

        if (requestParameters.ids) {
            queryParameters['ids'] = requestParameters.ids;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan/autoplan/dependencies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGraphneProductionPlanAutoplanDependencies(requestParameters: GetGraphneProductionPlanAutoplanDependenciesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutoPlanRequestDependencies> {
        const response = await this.getGraphneProductionPlanAutoplanDependenciesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all Queues
     */
    async getGraphneQueuesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Queue>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/queues`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all Queues
     */
    async getGraphneQueues(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Queue>> {
        const response = await this.getGraphneQueuesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns Queue by it\'s id
     */
    async getGraphneQueuesQueueidRaw(requestParameters: GetGraphneQueuesQueueidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Queue>> {
        if (requestParameters.queueId === null || requestParameters.queueId === undefined) {
            throw new runtime.RequiredError('queueId','Required parameter requestParameters.queueId was null or undefined when calling getGraphneQueuesQueueid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/queues/{queueId}`.replace(`{${"queueId"}}`, encodeURIComponent(String(requestParameters.queueId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns Queue by it\'s id
     */
    async getGraphneQueuesQueueid(requestParameters: GetGraphneQueuesQueueidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Queue> {
        const response = await this.getGraphneQueuesQueueidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneResourcesGroupListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResourceGroup>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/group/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGraphneResourcesGroupList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResourceGroup>> {
        const response = await this.getGraphneResourcesGroupListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneResourcesSoftPossibleTasksResourceidRaw(requestParameters: GetGraphneResourcesSoftPossibleTasksResourceidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ShortObjectView>>> {
        if (requestParameters.resourceId === null || requestParameters.resourceId === undefined) {
            throw new runtime.RequiredError('resourceId','Required parameter requestParameters.resourceId was null or undefined when calling getGraphneResourcesSoftPossibleTasksResourceid.');
        }

        const queryParameters: any = {};

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/possible-tasks/{ResourceId}`.replace(`{${"ResourceId"}}`, encodeURIComponent(String(requestParameters.resourceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getGraphneResourcesSoftPossibleTasksResourceid(requestParameters: GetGraphneResourcesSoftPossibleTasksResourceidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ShortObjectView>> {
        const response = await this.getGraphneResourcesSoftPossibleTasksResourceidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns status of applying simulation tasks to live plan asynchronously
     */
    async getGraphneSimulationApplyStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationApplyingStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/apply/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns status of applying simulation tasks to live plan asynchronously
     */
    async getGraphneSimulationApplyStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationApplyingStatus> {
        const response = await this.getGraphneSimulationApplyStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns all existing parameters for simulation creation
     */
    async getGraphneSimulationParametersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SimulationParameterView>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/parameters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all existing parameters for simulation creation
     */
    async getGraphneSimulationParameters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SimulationParameterView>> {
        const response = await this.getGraphneSimulationParametersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getGraphneSimulationSimulationidGanttUpdatesRaw(requestParameters: GetGraphneSimulationSimulationidGanttUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling getGraphneSimulationSimulationidGanttUpdates.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getGraphneSimulationSimulationidGanttUpdates.');
        }

        if (requestParameters.to === null || requestParameters.to === undefined) {
            throw new runtime.RequiredError('to','Required parameter requestParameters.to was null or undefined when calling getGraphneSimulationSimulationidGanttUpdates.');
        }

        const queryParameters: any = {};

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.to !== undefined) {
            queryParameters['to'] = requestParameters.to;
        }

        if (requestParameters.queues) {
            queryParameters['queues'] = requestParameters.queues;
        }

        if (requestParameters.withDependenciesDetails !== undefined) {
            queryParameters['withDependenciesDetails'] = requestParameters.withDependenciesDetails;
        }

        if (requestParameters.lotNumbers) {
            queryParameters['lotNumbers'] = requestParameters.lotNumbers;
        }

        if (requestParameters.isBehindSchedule !== undefined) {
            queryParameters['isBehindSchedule'] = requestParameters.isBehindSchedule;
        }

        if (requestParameters.requiresAcceptance !== undefined) {
            queryParameters['requiresAcceptance'] = requestParameters.requiresAcceptance;
        }

        if (requestParameters.priority !== undefined) {
            queryParameters['priority'] = requestParameters.priority;
        }

        if (requestParameters.onlyQueuesWithTasks !== undefined) {
            queryParameters['onlyQueuesWithTasks'] = requestParameters.onlyQueuesWithTasks;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/gantt/updates`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async getGraphneSimulationSimulationidGanttUpdates(requestParameters: GetGraphneSimulationSimulationidGanttUpdatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getGraphneSimulationSimulationidGanttUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns simulation metadata
     */
    async getGraphneSimulationSimulationidMetadataRaw(requestParameters: GetGraphneSimulationSimulationidMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationMetadataView>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling getGraphneSimulationSimulationidMetadata.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/metadata`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns simulation metadata
     */
    async getGraphneSimulationSimulationidMetadata(requestParameters: GetGraphneSimulationSimulationidMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationMetadataView> {
        const response = await this.getGraphneSimulationSimulationidMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get tasks to edit
     */
    async getGraphneSimulationSimulationidTasksRaw(requestParameters: GetGraphneSimulationSimulationidTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TaskView>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling getGraphneSimulationSimulationidTasks.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getGraphneSimulationSimulationidTasks.');
        }

        if (requestParameters.pageSize === null || requestParameters.pageSize === undefined) {
            throw new runtime.RequiredError('pageSize','Required parameter requestParameters.pageSize was null or undefined when calling getGraphneSimulationSimulationidTasks.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['pageSize'] = requestParameters.pageSize;
        }

        if (requestParameters.queueId !== undefined) {
            queryParameters['queueId'] = requestParameters.queueId;
        }

        if (requestParameters.queueAreaId !== undefined) {
            queryParameters['queueAreaId'] = requestParameters.queueAreaId;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.productionStartFromDateTime !== undefined) {
            queryParameters['productionStartFromDateTime'] = requestParameters.productionStartFromDateTime;
        }

        if (requestParameters.productionStartToDateTime !== undefined) {
            queryParameters['productionStartToDateTime'] = requestParameters.productionStartToDateTime;
        }

        if (requestParameters.queueIds) {
            queryParameters['queueIds'] = requestParameters.queueIds;
        }

        if (requestParameters.queueAreaIds) {
            queryParameters['queueAreaIds'] = requestParameters.queueAreaIds;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sortBy'] = requestParameters.sortBy;
        }

        if (requestParameters.sortOrder !== undefined) {
            queryParameters['sortOrder'] = requestParameters.sortOrder;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get tasks to edit
     */
    async getGraphneSimulationSimulationidTasks(requestParameters: GetGraphneSimulationSimulationidTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TaskView>> {
        const response = await this.getGraphneSimulationSimulationidTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List available recipes version names for task
     */
    async getGraphneSimulationSimulationidTasksP1RecipesversionnamesRaw(requestParameters: GetGraphneSimulationSimulationidTasksP1RecipesversionnamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling getGraphneSimulationSimulationidTasksP1Recipesversionnames.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getGraphneSimulationSimulationidTasksP1Recipesversionnames.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/recipesVersionNames`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List available recipes version names for task
     */
    async getGraphneSimulationSimulationidTasksP1Recipesversionnames(requestParameters: GetGraphneSimulationSimulationidTasksP1RecipesversionnamesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getGraphneSimulationSimulationidTasksP1RecipesversionnamesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get merge candidates for task
     */
    async getGraphneSimulationTasksP1MergecandidatesRaw(requestParameters: GetGraphneSimulationTasksP1MergecandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Task>>> {
        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling getGraphneSimulationTasksP1Mergecandidates.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/tasks/{p1}/mergeCandidates`.replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Get merge candidates for task
     */
    async getGraphneSimulationTasksP1Mergecandidates(requestParameters: GetGraphneSimulationTasksP1MergecandidatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Task>> {
        const response = await this.getGraphneSimulationTasksP1MergecandidatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns TaskView entity by Task id
     */
    async getGraphneTasksTaskidRaw(requestParameters: GetGraphneTasksTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskView>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getGraphneTasksTaskid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/tasks/{taskId}`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns TaskView entity by Task id
     */
    async getGraphneTasksTaskid(requestParameters: GetGraphneTasksTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskView> {
        const response = await this.getGraphneTasksTaskidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all queues that are available to plan task on them
     */
    async getGraphneTasksTaskidAvailableQueuesRaw(requestParameters: GetGraphneTasksTaskidAvailableQueuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskAvailableQueues>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getGraphneTasksTaskidAvailableQueues.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/tasks/{taskId}/available-queues`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns all queues that are available to plan task on them
     */
    async getGraphneTasksTaskidAvailableQueues(requestParameters: GetGraphneTasksTaskidAvailableQueuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskAvailableQueues> {
        const response = await this.getGraphneTasksTaskidAvailableQueuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns forecasted execution duration for task started at given time on current production plan
     */
    async getGraphneTasksTaskidDurationForecastRaw(requestParameters: GetGraphneTasksTaskidDurationForecastRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getGraphneTasksTaskidDurationForecast.');
        }

        if (requestParameters.queueId === null || requestParameters.queueId === undefined) {
            throw new runtime.RequiredError('queueId','Required parameter requestParameters.queueId was null or undefined when calling getGraphneTasksTaskidDurationForecast.');
        }

        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getGraphneTasksTaskidDurationForecast.');
        }

        const queryParameters: any = {};

        if (requestParameters.queueId !== undefined) {
            queryParameters['queueId'] = requestParameters.queueId;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/tasks/{taskId}/duration-forecast`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Returns forecasted execution duration for task started at given time on current production plan
     */
    async getGraphneTasksTaskidDurationForecast(requestParameters: GetGraphneTasksTaskidDurationForecastRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.getGraphneTasksTaskidDurationForecastRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns ingredients (BOM) required by the task together with explicitly marked missing stocks (matching the Gantt representation). Missing ingredients are listed first.
     */
    async getGraphneTasksTaskidIngredientsRaw(requestParameters: GetGraphneTasksTaskidIngredientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TaskIngredientsView>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getGraphneTasksTaskidIngredients.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/tasks/{taskId}/ingredients`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns ingredients (BOM) required by the task together with explicitly marked missing stocks (matching the Gantt representation). Missing ingredients are listed first.
     */
    async getGraphneTasksTaskidIngredients(requestParameters: GetGraphneTasksTaskidIngredientsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TaskIngredientsView> {
        const response = await this.getGraphneTasksTaskidIngredientsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns forecasted execution duration for task started at given time on current production plan
     */
    async getGraphneTasksTaskidQueueDurationForecastRaw(requestParameters: GetGraphneTasksTaskidQueueDurationForecastRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueueDurationForecast>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling getGraphneTasksTaskidQueueDurationForecast.');
        }

        if (requestParameters.queueId === null || requestParameters.queueId === undefined) {
            throw new runtime.RequiredError('queueId','Required parameter requestParameters.queueId was null or undefined when calling getGraphneTasksTaskidQueueDurationForecast.');
        }

        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start','Required parameter requestParameters.start was null or undefined when calling getGraphneTasksTaskidQueueDurationForecast.');
        }

        const queryParameters: any = {};

        if (requestParameters.queueId !== undefined) {
            queryParameters['queueId'] = requestParameters.queueId;
        }

        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/tasks/{taskId}/queue-duration-forecast`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Returns forecasted execution duration for task started at given time on current production plan
     */
    async getGraphneTasksTaskidQueueDurationForecast(requestParameters: GetGraphneTasksTaskidQueueDurationForecastRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueueDurationForecast> {
        const response = await this.getGraphneTasksTaskidQueueDurationForecastRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update Queue properties
     */
    async patchGraphneQueuesQueueidPropertiesRaw(requestParameters: PatchGraphneQueuesQueueidPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Queue>> {
        if (requestParameters.queueId === null || requestParameters.queueId === undefined) {
            throw new runtime.RequiredError('queueId','Required parameter requestParameters.queueId was null or undefined when calling patchGraphneQueuesQueueidProperties.');
        }

        if (requestParameters.queueProperties === null || requestParameters.queueProperties === undefined) {
            throw new runtime.RequiredError('queueProperties','Required parameter requestParameters.queueProperties was null or undefined when calling patchGraphneQueuesQueueidProperties.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/queues/{queueId}/properties`.replace(`{${"queueId"}}`, encodeURIComponent(String(requestParameters.queueId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.queueProperties,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Update Queue properties
     */
    async patchGraphneQueuesQueueidProperties(requestParameters: PatchGraphneQueuesQueueidPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Queue> {
        const response = await this.patchGraphneQueuesQueueidPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists retooling matrices with paging (take/skip), optional ordering, and description/parameter/queue id filtering
     */
    async postGraphneInternalRetoolingMatrixListRaw(requestParameters: PostGraphneInternalRetoolingMatrixListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetoolingMatrixListResult>> {
        if (requestParameters.retoolingMatrixListRequest === null || requestParameters.retoolingMatrixListRequest === undefined) {
            throw new runtime.RequiredError('retoolingMatrixListRequest','Required parameter requestParameters.retoolingMatrixListRequest was null or undefined when calling postGraphneInternalRetoolingMatrixList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/internal/retooling-matrix/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.retoolingMatrixListRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Lists retooling matrices with paging (take/skip), optional ordering, and description/parameter/queue id filtering
     */
    async postGraphneInternalRetoolingMatrixList(requestParameters: PostGraphneInternalRetoolingMatrixListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetoolingMatrixListResult> {
        const response = await this.postGraphneInternalRetoolingMatrixListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deprecated because it\'s now done as part of simulations
     */
    async postGraphneProductionPlanAutoplanRaw(requestParameters: PostGraphneProductionPlanAutoplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan/autoplan`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deprecated because it\'s now done as part of simulations
     */
    async postGraphneProductionPlanAutoplan(requestParameters: PostGraphneProductionPlanAutoplanRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneProductionPlanAutoplanRaw(requestParameters, initOverrides);
    }

    /**
     * Deprecated because it\'s now done as part of simulations
     */
    async postGraphneProductionPlanAutoplanPullPlaningRaw(requestParameters: PostGraphneProductionPlanAutoplanPullPlaningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.autoPlanRequest === null || requestParameters.autoPlanRequest === undefined) {
            throw new runtime.RequiredError('autoPlanRequest','Required parameter requestParameters.autoPlanRequest was null or undefined when calling postGraphneProductionPlanAutoplanPullPlaning.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan/autoplan/pull-planing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.autoPlanRequest,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deprecated because it\'s now done as part of simulations
     */
    async postGraphneProductionPlanAutoplanPullPlaning(requestParameters: PostGraphneProductionPlanAutoplanPullPlaningRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneProductionPlanAutoplanPullPlaningRaw(requestParameters, initOverrides);
    }

    /**
     * Add Task to plan given queue and expected start time
     */
    async postGraphneProductionPlanEntriesRaw(requestParameters: PostGraphneProductionPlanEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.taskAddEntry === null || requestParameters.taskAddEntry === undefined) {
            throw new runtime.RequiredError('taskAddEntry','Required parameter requestParameters.taskAddEntry was null or undefined when calling postGraphneProductionPlanEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan-entries`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.taskAddEntry,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add Task to plan given queue and expected start time
     */
    async postGraphneProductionPlanEntries(requestParameters: PostGraphneProductionPlanEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneProductionPlanEntriesRaw(requestParameters, initOverrides);
    }

    /**
     * Move single production entry for a whole batch
     */
    async postGraphneProductionPlanEntriesBatchMoveRaw(requestParameters: PostGraphneProductionPlanEntriesBatchMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionPlanBatchEntryView === null || requestParameters.productionPlanBatchEntryView === undefined) {
            throw new runtime.RequiredError('productionPlanBatchEntryView','Required parameter requestParameters.productionPlanBatchEntryView was null or undefined when calling postGraphneProductionPlanEntriesBatchMove.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan-entries/batch/move`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionPlanBatchEntryView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Move single production entry for a whole batch
     */
    async postGraphneProductionPlanEntriesBatchMove(requestParameters: PostGraphneProductionPlanEntriesBatchMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneProductionPlanEntriesBatchMoveRaw(requestParameters, initOverrides);
    }

    /**
     * Move single production entry for a single task
     */
    async postGraphneProductionPlanEntriesMoveRaw(requestParameters: PostGraphneProductionPlanEntriesMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.productionPlanEntry === null || requestParameters.productionPlanEntry === undefined) {
            throw new runtime.RequiredError('productionPlanEntry','Required parameter requestParameters.productionPlanEntry was null or undefined when calling postGraphneProductionPlanEntriesMove.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan-entries/move`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionPlanEntry,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Move single production entry for a single task
     */
    async postGraphneProductionPlanEntriesMove(requestParameters: PostGraphneProductionPlanEntriesMoveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneProductionPlanEntriesMoveRaw(requestParameters, initOverrides);
    }

    /**
     * Deprecated because it\'s now done as part of simulations
     */
    async postGraphneProductionPlanOptimizeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-plan/optimize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deprecated because it\'s now done as part of simulations
     */
    async postGraphneProductionPlanOptimize(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneProductionPlanOptimizeRaw(initOverrides);
    }

    /**
     * Saves Queue
     */
    async postGraphneQueuesRaw(requestParameters: PostGraphneQueuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Queue>> {
        if (requestParameters.queue === null || requestParameters.queue === undefined) {
            throw new runtime.RequiredError('queue','Required parameter requestParameters.queue was null or undefined when calling postGraphneQueues.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/queues`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.queue,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Saves Queue
     */
    async postGraphneQueues(requestParameters: PostGraphneQueuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Queue> {
        const response = await this.postGraphneQueuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postGraphneResourcesGroupTimeframeResourcegroupidRaw(requestParameters: PostGraphneResourcesGroupTimeframeResourcegroupidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResourceGroupTimeframeDetailsView>> {
        if (requestParameters.resourceGroupId === null || requestParameters.resourceGroupId === undefined) {
            throw new runtime.RequiredError('resourceGroupId','Required parameter requestParameters.resourceGroupId was null or undefined when calling postGraphneResourcesGroupTimeframeResourcegroupid.');
        }

        if (requestParameters.getGroupDetailsFilter === null || requestParameters.getGroupDetailsFilter === undefined) {
            throw new runtime.RequiredError('getGroupDetailsFilter','Required parameter requestParameters.getGroupDetailsFilter was null or undefined when calling postGraphneResourcesGroupTimeframeResourcegroupid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/group/timeframe/{ResourceGroupId}`.replace(`{${"ResourceGroupId"}}`, encodeURIComponent(String(requestParameters.resourceGroupId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.getGroupDetailsFilter,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesGroupTimeframeResourcegroupid(requestParameters: PostGraphneResourcesGroupTimeframeResourcegroupidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResourceGroupTimeframeDetailsView> {
        const response = await this.postGraphneResourcesGroupTimeframeResourcegroupidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postGraphneResourcesSoftAssignRaw(requestParameters: PostGraphneResourcesSoftAssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/assign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceAssignment,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftAssign(requestParameters: PostGraphneResourcesSoftAssignRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftAssignRaw(requestParameters, initOverrides);
    }

    /**
     */
    async postGraphneResourcesSoftAssignBatchRaw(requestParameters: PostGraphneResourcesSoftAssignBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/assign/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceBatchAssignment,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftAssignBatch(requestParameters: PostGraphneResourcesSoftAssignBatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftAssignBatchRaw(requestParameters, initOverrides);
    }

    /**
     * This endpoint is used when a user wants to assign a worker to a task, even though the worker is already assigned to another task at the same time. User is informed about that and must explicitly confirm that on UI.
     */
    async postGraphneResourcesSoftAssignWithoutValidationRaw(requestParameters: PostGraphneResourcesSoftAssignWithoutValidationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/assign-without-validation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceAssignment,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint is used when a user wants to assign a worker to a task, even though the worker is already assigned to another task at the same time. User is informed about that and must explicitly confirm that on UI.
     */
    async postGraphneResourcesSoftAssignWithoutValidation(requestParameters: PostGraphneResourcesSoftAssignWithoutValidationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftAssignWithoutValidationRaw(requestParameters, initOverrides);
    }

    /**
     * This endpoint is used when a user wants to assign a worker to a task, even though the worker is already assigned to another task at the same time. User is informed about that and must explicitly confirm that on UI.
     */
    async postGraphneResourcesSoftAssignWithoutValidationBatchRaw(requestParameters: PostGraphneResourcesSoftAssignWithoutValidationBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/assign-without-validation/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceBatchAssignment,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * This endpoint is used when a user wants to assign a worker to a task, even though the worker is already assigned to another task at the same time. User is informed about that and must explicitly confirm that on UI.
     */
    async postGraphneResourcesSoftAssignWithoutValidationBatch(requestParameters: PostGraphneResourcesSoftAssignWithoutValidationBatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftAssignWithoutValidationBatchRaw(requestParameters, initOverrides);
    }

    /**
     */
    async postGraphneResourcesSoftAssignmentBatchBatchidRaw(requestParameters: PostGraphneResourcesSoftAssignmentBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResourceAvailabilityMeta>>> {
        if (requestParameters.batchId === null || requestParameters.batchId === undefined) {
            throw new runtime.RequiredError('batchId','Required parameter requestParameters.batchId was null or undefined when calling postGraphneResourcesSoftAssignmentBatchBatchid.');
        }

        if (requestParameters.softResourcesAssignmentFilter === null || requestParameters.softResourcesAssignmentFilter === undefined) {
            throw new runtime.RequiredError('softResourcesAssignmentFilter','Required parameter requestParameters.softResourcesAssignmentFilter was null or undefined when calling postGraphneResourcesSoftAssignmentBatchBatchid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/assignment/batch/{BatchId}`.replace(`{${"BatchId"}}`, encodeURIComponent(String(requestParameters.batchId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourcesAssignmentFilter,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftAssignmentBatchBatchid(requestParameters: PostGraphneResourcesSoftAssignmentBatchBatchidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResourceAvailabilityMeta>> {
        const response = await this.postGraphneResourcesSoftAssignmentBatchBatchidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postGraphneResourcesSoftAssignmentTaskidRaw(requestParameters: PostGraphneResourcesSoftAssignmentTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResourceAvailabilityMeta>>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling postGraphneResourcesSoftAssignmentTaskid.');
        }

        if (requestParameters.softResourcesAssignmentFilter === null || requestParameters.softResourcesAssignmentFilter === undefined) {
            throw new runtime.RequiredError('softResourcesAssignmentFilter','Required parameter requestParameters.softResourcesAssignmentFilter was null or undefined when calling postGraphneResourcesSoftAssignmentTaskid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/assignment/{TaskId}`.replace(`{${"TaskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourcesAssignmentFilter,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftAssignmentTaskid(requestParameters: PostGraphneResourcesSoftAssignmentTaskidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResourceAvailabilityMeta>> {
        const response = await this.postGraphneResourcesSoftAssignmentTaskidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postGraphneResourcesSoftUnassignRaw(requestParameters: PostGraphneResourcesSoftUnassignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/unassign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceAssignment,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftUnassign(requestParameters: PostGraphneResourcesSoftUnassignRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftUnassignRaw(requestParameters, initOverrides);
    }

    /**
     * Unassign all soft resources from pending tasks in a queue area whose planned start falls in the given time window. Publishes soft assignments to Nexelem.
     */
    async postGraphneResourcesSoftUnassignAllRaw(requestParameters: PostGraphneResourcesSoftUnassignAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoftResourceAreaUnassignmentResultView>> {
        if (requestParameters.softResourceAreaUnassignmentRequest === null || requestParameters.softResourceAreaUnassignmentRequest === undefined) {
            throw new runtime.RequiredError('softResourceAreaUnassignmentRequest','Required parameter requestParameters.softResourceAreaUnassignmentRequest was null or undefined when calling postGraphneResourcesSoftUnassignAll.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/unassign-all`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceAreaUnassignmentRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Unassign all soft resources from pending tasks in a queue area whose planned start falls in the given time window. Publishes soft assignments to Nexelem.
     */
    async postGraphneResourcesSoftUnassignAll(requestParameters: PostGraphneResourcesSoftUnassignAllRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoftResourceAreaUnassignmentResultView> {
        const response = await this.postGraphneResourcesSoftUnassignAllRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postGraphneResourcesSoftUnassignBatchRaw(requestParameters: PostGraphneResourcesSoftUnassignBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/unassign/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceBatchAssignment,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftUnassignBatch(requestParameters: PostGraphneResourcesSoftUnassignBatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftUnassignBatchRaw(requestParameters, initOverrides);
    }

    /**
     * Unassign soft resources from pending tasks in a queue area when they are not calendar-available in the given time window. Publishes soft assignments to Nexelem.
     */
    async postGraphneResourcesSoftUnassignUnavailableRaw(requestParameters: PostGraphneResourcesSoftUnassignUnavailableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SoftResourceAreaUnassignmentResultView>> {
        if (requestParameters.softResourceAreaUnassignmentRequest === null || requestParameters.softResourceAreaUnassignmentRequest === undefined) {
            throw new runtime.RequiredError('softResourceAreaUnassignmentRequest','Required parameter requestParameters.softResourceAreaUnassignmentRequest was null or undefined when calling postGraphneResourcesSoftUnassignUnavailable.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/unassign-unavailable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceAreaUnassignmentRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Unassign soft resources from pending tasks in a queue area when they are not calendar-available in the given time window. Publishes soft assignments to Nexelem.
     */
    async postGraphneResourcesSoftUnassignUnavailable(requestParameters: PostGraphneResourcesSoftUnassignUnavailableRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SoftResourceAreaUnassignmentResultView> {
        const response = await this.postGraphneResourcesSoftUnassignUnavailableRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postGraphneResourcesSoftV2AssignRaw(requestParameters: PostGraphneResourcesSoftV2AssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.softResourceAssignmentV2 === null || requestParameters.softResourceAssignmentV2 === undefined) {
            throw new runtime.RequiredError('softResourceAssignmentV2','Required parameter requestParameters.softResourceAssignmentV2 was null or undefined when calling postGraphneResourcesSoftV2Assign.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/v2/assign`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceAssignmentV2,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftV2Assign(requestParameters: PostGraphneResourcesSoftV2AssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftV2AssignRaw(requestParameters, initOverrides);
    }

    /**
     */
    async postGraphneResourcesSoftV2AssignBatchRaw(requestParameters: PostGraphneResourcesSoftV2AssignBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.softResourceBatchAssignmentV2 === null || requestParameters.softResourceBatchAssignmentV2 === undefined) {
            throw new runtime.RequiredError('softResourceBatchAssignmentV2','Required parameter requestParameters.softResourceBatchAssignmentV2 was null or undefined when calling postGraphneResourcesSoftV2AssignBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/resources/soft/v2/assign/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.softResourceBatchAssignmentV2,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async postGraphneResourcesSoftV2AssignBatch(requestParameters: PostGraphneResourcesSoftV2AssignBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneResourcesSoftV2AssignBatchRaw(requestParameters, initOverrides);
    }

    /**
     * Applies given simulation tasks to live plan
     */
    async postGraphneSimulationApplyRaw(requestParameters: PostGraphneSimulationApplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationApplyView === null || requestParameters.simulationApplyView === undefined) {
            throw new runtime.RequiredError('simulationApplyView','Required parameter requestParameters.simulationApplyView was null or undefined when calling postGraphneSimulationApply.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/apply`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationApplyView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Applies given simulation tasks to live plan
     */
    async postGraphneSimulationApply(requestParameters: PostGraphneSimulationApplyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationApplyRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new simulation given list of parameter values
     */
    async postGraphneSimulationCreateRaw(requestParameters: PostGraphneSimulationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.simulationCreateOptimizeView === null || requestParameters.simulationCreateOptimizeView === undefined) {
            throw new runtime.RequiredError('simulationCreateOptimizeView','Required parameter requestParameters.simulationCreateOptimizeView was null or undefined when calling postGraphneSimulationCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationCreateOptimizeView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Creates a new simulation given list of parameter values
     */
    async postGraphneSimulationCreate(requestParameters: PostGraphneSimulationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postGraphneSimulationCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List of simulations
     */
    async postGraphneSimulationListRaw(requestParameters: PostGraphneSimulationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationListResult>> {
        if (requestParameters.simulationFilterDefinition === null || requestParameters.simulationFilterDefinition === undefined) {
            throw new runtime.RequiredError('simulationFilterDefinition','Required parameter requestParameters.simulationFilterDefinition was null or undefined when calling postGraphneSimulationList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationFilterDefinition,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * List of simulations
     */
    async postGraphneSimulationList(requestParameters: PostGraphneSimulationListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationListResult> {
        const response = await this.postGraphneSimulationListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deprecated, replaced by separate endpoints for saving freezing/planning boundaries
     */
    async postGraphneSimulationMetadataSaveRaw(requestParameters: PostGraphneSimulationMetadataSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationMetadataSaveView === null || requestParameters.simulationMetadataSaveView === undefined) {
            throw new runtime.RequiredError('simulationMetadataSaveView','Required parameter requestParameters.simulationMetadataSaveView was null or undefined when calling postGraphneSimulationMetadataSave.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/metadata/save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationMetadataSaveView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deprecated, replaced by separate endpoints for saving freezing/planning boundaries
     */
    async postGraphneSimulationMetadataSave(requestParameters: PostGraphneSimulationMetadataSaveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationMetadataSaveRaw(requestParameters, initOverrides);
    }

    /**
     * Edits simulation\'s freezing boundary
     */
    async postGraphneSimulationMetadataSaveFreezingBoundaryRaw(requestParameters: PostGraphneSimulationMetadataSaveFreezingBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.freezingBoundarySaveView === null || requestParameters.freezingBoundarySaveView === undefined) {
            throw new runtime.RequiredError('freezingBoundarySaveView','Required parameter requestParameters.freezingBoundarySaveView was null or undefined when calling postGraphneSimulationMetadataSaveFreezingBoundary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/metadata/save/freezing-boundary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.freezingBoundarySaveView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Edits simulation\'s freezing boundary
     */
    async postGraphneSimulationMetadataSaveFreezingBoundary(requestParameters: PostGraphneSimulationMetadataSaveFreezingBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationMetadataSaveFreezingBoundaryRaw(requestParameters, initOverrides);
    }

    /**
     * Edits simulation\'s planning boundary
     */
    async postGraphneSimulationMetadataSavePlanningBoundaryRaw(requestParameters: PostGraphneSimulationMetadataSavePlanningBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.planningBoundarySaveView === null || requestParameters.planningBoundarySaveView === undefined) {
            throw new runtime.RequiredError('planningBoundarySaveView','Required parameter requestParameters.planningBoundarySaveView was null or undefined when calling postGraphneSimulationMetadataSavePlanningBoundary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/metadata/save/planning-boundary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.planningBoundarySaveView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Edits simulation\'s planning boundary
     */
    async postGraphneSimulationMetadataSavePlanningBoundary(requestParameters: PostGraphneSimulationMetadataSavePlanningBoundaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationMetadataSavePlanningBoundaryRaw(requestParameters, initOverrides);
    }

    /**
     * Autoplans as part of a simulation
     */
    async postGraphneSimulationSimulationidAutoplanRaw(requestParameters: PostGraphneSimulationSimulationidAutoplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidAutoplan.');
        }

        if (requestParameters.autoPlanRequest === null || requestParameters.autoPlanRequest === undefined) {
            throw new runtime.RequiredError('autoPlanRequest','Required parameter requestParameters.autoPlanRequest was null or undefined when calling postGraphneSimulationSimulationidAutoplan.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/autoplan`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.autoPlanRequest,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Autoplans as part of a simulation
     */
    async postGraphneSimulationSimulationidAutoplan(requestParameters: PostGraphneSimulationSimulationidAutoplanRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationSimulationidAutoplanRaw(requestParameters, initOverrides);
    }

    /**
     * Freezes batch in simulation including whole dependency graph of batch, returns ids of tasks which were frozen. Returns empty array when task and all it\'s dependency graph have already been frozen
     */
    async postGraphneSimulationSimulationidBatchesP1FreezeRaw(requestParameters: PostGraphneSimulationSimulationidBatchesP1FreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidBatchesP1Freeze.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidBatchesP1Freeze.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/batches/{p1}/freeze`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Freezes batch in simulation including whole dependency graph of batch, returns ids of tasks which were frozen. Returns empty array when task and all it\'s dependency graph have already been frozen
     */
    async postGraphneSimulationSimulationidBatchesP1Freeze(requestParameters: PostGraphneSimulationSimulationidBatchesP1FreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidBatchesP1FreezeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks batch in simulation for publication including whole dependency graph of batch, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidBatchesP1MarkToPublishRaw(requestParameters: PostGraphneSimulationSimulationidBatchesP1MarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidBatchesP1MarkToPublish.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidBatchesP1MarkToPublish.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/batches/{p1}/mark-to-publish`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Marks batch in simulation for publication including whole dependency graph of batch, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidBatchesP1MarkToPublish(requestParameters: PostGraphneSimulationSimulationidBatchesP1MarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidBatchesP1MarkToPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Unfreezes batch in simulation including whole dependency graph of task, returns ids of tasks which were unfrozen. Returns empty array when task and all it\'s dependency graph have already been unfrozen
     */
    async postGraphneSimulationSimulationidBatchesP1UnfreezeRaw(requestParameters: PostGraphneSimulationSimulationidBatchesP1UnfreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidBatchesP1Unfreeze.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidBatchesP1Unfreeze.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/batches/{p1}/unfreeze`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Unfreezes batch in simulation including whole dependency graph of task, returns ids of tasks which were unfrozen. Returns empty array when task and all it\'s dependency graph have already been unfrozen
     */
    async postGraphneSimulationSimulationidBatchesP1Unfreeze(requestParameters: PostGraphneSimulationSimulationidBatchesP1UnfreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidBatchesP1UnfreezeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears publication mark for batch in simulation including whole dependency graph of batch, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidBatchesP1UnmarkToPublishRaw(requestParameters: PostGraphneSimulationSimulationidBatchesP1UnmarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidBatchesP1UnmarkToPublish.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidBatchesP1UnmarkToPublish.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/batches/{p1}/unmark-to-publish`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears publication mark for batch in simulation including whole dependency graph of batch, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidBatchesP1UnmarkToPublish(requestParameters: PostGraphneSimulationSimulationidBatchesP1UnmarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidBatchesP1UnmarkToPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new simulation given list of parameter values
     */
    async postGraphneSimulationSimulationidOptimizeRaw(requestParameters: PostGraphneSimulationSimulationidOptimizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidOptimize.');
        }

        if (requestParameters.simulationCreateOptimizeView === null || requestParameters.simulationCreateOptimizeView === undefined) {
            throw new runtime.RequiredError('simulationCreateOptimizeView','Required parameter requestParameters.simulationCreateOptimizeView was null or undefined when calling postGraphneSimulationSimulationidOptimize.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/optimize`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationCreateOptimizeView,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Creates a new simulation given list of parameter values
     */
    async postGraphneSimulationSimulationidOptimize(requestParameters: PostGraphneSimulationSimulationidOptimizeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<number> {
        const response = await this.postGraphneSimulationSimulationidOptimizeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel many simulation tasks at once
     */
    async postGraphneSimulationSimulationidTasksCancelRaw(requestParameters: PostGraphneSimulationSimulationidTasksCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksCancel.');
        }

        if (requestParameters.simulationCancelTasksView === null || requestParameters.simulationCancelTasksView === undefined) {
            throw new runtime.RequiredError('simulationCancelTasksView','Required parameter requestParameters.simulationCancelTasksView was null or undefined when calling postGraphneSimulationSimulationidTasksCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/cancel`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationCancelTasksView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel many simulation tasks at once
     */
    async postGraphneSimulationSimulationidTasksCancel(requestParameters: PostGraphneSimulationSimulationidTasksCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationSimulationidTasksCancelRaw(requestParameters, initOverrides);
    }

    /**
     * Update simulation task amount
     */
    async postGraphneSimulationSimulationidTasksP1AmountRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1AmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1Amount.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1Amount.');
        }

        if (requestParameters.simulationTaskUpdateAmountView === null || requestParameters.simulationTaskUpdateAmountView === undefined) {
            throw new runtime.RequiredError('simulationTaskUpdateAmountView','Required parameter requestParameters.simulationTaskUpdateAmountView was null or undefined when calling postGraphneSimulationSimulationidTasksP1Amount.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/amount`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationTaskUpdateAmountView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update simulation task amount
     */
    async postGraphneSimulationSimulationidTasksP1Amount(requestParameters: PostGraphneSimulationSimulationidTasksP1AmountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationSimulationidTasksP1AmountRaw(requestParameters, initOverrides);
    }

    /**
     * Freezes task in simulation including whole dependency graph of task, returns ids of tasks which were frozen. Returns empty array when task and all it\'s dependency graph have already been frozen
     */
    async postGraphneSimulationSimulationidTasksP1FreezeRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1FreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1Freeze.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1Freeze.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/freeze`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Freezes task in simulation including whole dependency graph of task, returns ids of tasks which were frozen. Returns empty array when task and all it\'s dependency graph have already been frozen
     */
    async postGraphneSimulationSimulationidTasksP1Freeze(requestParameters: PostGraphneSimulationSimulationidTasksP1FreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidTasksP1FreezeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks task in simulation for publication including whole dependency graph of task, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidTasksP1MarkToPublishRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1MarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1MarkToPublish.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1MarkToPublish.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/mark-to-publish`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Marks task in simulation for publication including whole dependency graph of task, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidTasksP1MarkToPublish(requestParameters: PostGraphneSimulationSimulationidTasksP1MarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidTasksP1MarkToPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update simulation task recipe version name
     */
    async postGraphneSimulationSimulationidTasksP1RecipeversionnameRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1RecipeversionnameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1Recipeversionname.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1Recipeversionname.');
        }

        if (requestParameters.simulationTaskUpdateRecipeVersionName === null || requestParameters.simulationTaskUpdateRecipeVersionName === undefined) {
            throw new runtime.RequiredError('simulationTaskUpdateRecipeVersionName','Required parameter requestParameters.simulationTaskUpdateRecipeVersionName was null or undefined when calling postGraphneSimulationSimulationidTasksP1Recipeversionname.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/recipeVersionName`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationTaskUpdateRecipeVersionName,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update simulation task recipe version name
     */
    async postGraphneSimulationSimulationidTasksP1Recipeversionname(requestParameters: PostGraphneSimulationSimulationidTasksP1RecipeversionnameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationSimulationidTasksP1RecipeversionnameRaw(requestParameters, initOverrides);
    }

    /**
     * Update simulation task technology
     */
    async postGraphneSimulationSimulationidTasksP1TechnologyRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1TechnologyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1Technology.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1Technology.');
        }

        if (requestParameters.simulationTaskUpdateTechnologyView === null || requestParameters.simulationTaskUpdateTechnologyView === undefined) {
            throw new runtime.RequiredError('simulationTaskUpdateTechnologyView','Required parameter requestParameters.simulationTaskUpdateTechnologyView was null or undefined when calling postGraphneSimulationSimulationidTasksP1Technology.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/technology`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationTaskUpdateTechnologyView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update simulation task technology
     */
    async postGraphneSimulationSimulationidTasksP1Technology(requestParameters: PostGraphneSimulationSimulationidTasksP1TechnologyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationSimulationidTasksP1TechnologyRaw(requestParameters, initOverrides);
    }

    /**
     * Unfreezes task in simulation including whole dependency graph of task, returns ids of tasks which were unfrozen. Returns empty array when task and all it\'s dependency graph have already been unfrozen
     */
    async postGraphneSimulationSimulationidTasksP1UnfreezeRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1UnfreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1Unfreeze.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1Unfreeze.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/unfreeze`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Unfreezes task in simulation including whole dependency graph of task, returns ids of tasks which were unfrozen. Returns empty array when task and all it\'s dependency graph have already been unfrozen
     */
    async postGraphneSimulationSimulationidTasksP1Unfreeze(requestParameters: PostGraphneSimulationSimulationidTasksP1UnfreezeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidTasksP1UnfreezeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears publication mark for task in simulation including whole dependency graph of task, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidTasksP1UnmarkToPublishRaw(requestParameters: PostGraphneSimulationSimulationidTasksP1UnmarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<number>>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksP1UnmarkToPublish.');
        }

        if (requestParameters.p1 === null || requestParameters.p1 === undefined) {
            throw new runtime.RequiredError('p1','Required parameter requestParameters.p1 was null or undefined when calling postGraphneSimulationSimulationidTasksP1UnmarkToPublish.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/{p1}/unmark-to-publish`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))).replace(`{${"p1"}}`, encodeURIComponent(String(requestParameters.p1))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears publication mark for task in simulation including whole dependency graph of task, returns ids of tasks which were updated.
     */
    async postGraphneSimulationSimulationidTasksP1UnmarkToPublish(requestParameters: PostGraphneSimulationSimulationidTasksP1UnmarkToPublishRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<number>> {
        const response = await this.postGraphneSimulationSimulationidTasksP1UnmarkToPublishRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update simulation tasks (amount, recipe version name, priority, unplan)
     */
    async postGraphneSimulationSimulationidTasksUpdateRaw(requestParameters: PostGraphneSimulationSimulationidTasksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidTasksUpdate.');
        }

        if (requestParameters.simulationTasksUpdates === null || requestParameters.simulationTasksUpdates === undefined) {
            throw new runtime.RequiredError('simulationTasksUpdates','Required parameter requestParameters.simulationTasksUpdates was null or undefined when calling postGraphneSimulationSimulationidTasksUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/tasks/update`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationTasksUpdates,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update simulation tasks (amount, recipe version name, priority, unplan)
     */
    async postGraphneSimulationSimulationidTasksUpdate(requestParameters: PostGraphneSimulationSimulationidTasksUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneSimulationSimulationidTasksUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Validate simulation to new one
     */
    async postGraphneSimulationSimulationidValidateRaw(requestParameters: PostGraphneSimulationSimulationidValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimulationValidationResultView>> {
        if (requestParameters.simulationId === null || requestParameters.simulationId === undefined) {
            throw new runtime.RequiredError('simulationId','Required parameter requestParameters.simulationId was null or undefined when calling postGraphneSimulationSimulationidValidate.');
        }

        if (requestParameters.simulationCreateOptimizeView === null || requestParameters.simulationCreateOptimizeView === undefined) {
            throw new runtime.RequiredError('simulationCreateOptimizeView','Required parameter requestParameters.simulationCreateOptimizeView was null or undefined when calling postGraphneSimulationSimulationidValidate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/simulation/{simulationId}/validate`.replace(`{${"simulationId"}}`, encodeURIComponent(String(requestParameters.simulationId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.simulationCreateOptimizeView,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Validate simulation to new one
     */
    async postGraphneSimulationSimulationidValidate(requestParameters: PostGraphneSimulationSimulationidValidateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimulationValidationResultView> {
        const response = await this.postGraphneSimulationSimulationidValidateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ToDo List
     */
    async postGraphneTodoListRaw(requestParameters: PostGraphneTodoListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ToDoListView>> {
        if (requestParameters.taskFilterDefinition === null || requestParameters.taskFilterDefinition === undefined) {
            throw new runtime.RequiredError('taskFilterDefinition','Required parameter requestParameters.taskFilterDefinition was null or undefined when calling postGraphneTodoList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/todo/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.taskFilterDefinition,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * ToDo List
     */
    async postGraphneTodoList(requestParameters: PostGraphneTodoListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ToDoListView> {
        const response = await this.postGraphneTodoListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Cancel many todo tasks at once
     */
    async postGraphneTodoTasksCancelRaw(requestParameters: PostGraphneTodoTasksCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.cancelToDoTasksView === null || requestParameters.cancelToDoTasksView === undefined) {
            throw new runtime.RequiredError('cancelToDoTasksView','Required parameter requestParameters.cancelToDoTasksView was null or undefined when calling postGraphneTodoTasksCancel.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/todo/tasks/cancel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.cancelToDoTasksView,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Cancel many todo tasks at once
     */
    async postGraphneTodoTasksCancel(requestParameters: PostGraphneTodoTasksCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.postGraphneTodoTasksCancelRaw(requestParameters, initOverrides);
    }

    /**
     * ToDo Tree List
     */
    async postGraphneTodoTreeRaw(requestParameters: PostGraphneTodoTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ToDoTrees>> {
        if (requestParameters.taskFilterDefinition === null || requestParameters.taskFilterDefinition === undefined) {
            throw new runtime.RequiredError('taskFilterDefinition','Required parameter requestParameters.taskFilterDefinition was null or undefined when calling postGraphneTodoTree.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/todo/tree`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.taskFilterDefinition,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * ToDo Tree List
     */
    async postGraphneTodoTree(requestParameters: PostGraphneTodoTreeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ToDoTrees> {
        const response = await this.postGraphneTodoTreeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replaces a retooling matrix\'s metadata (queue links and description) in full
     */
    async putGraphneInternalRetoolingMatrixMetadataRetoolingmatrixidRaw(requestParameters: PutGraphneInternalRetoolingMatrixMetadataRetoolingmatrixidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RetoolingMatrixMetadata>> {
        if (requestParameters.retoolingMatrixId === null || requestParameters.retoolingMatrixId === undefined) {
            throw new runtime.RequiredError('retoolingMatrixId','Required parameter requestParameters.retoolingMatrixId was null or undefined when calling putGraphneInternalRetoolingMatrixMetadataRetoolingmatrixid.');
        }

        if (requestParameters.retoolingMatrixMetadata === null || requestParameters.retoolingMatrixMetadata === undefined) {
            throw new runtime.RequiredError('retoolingMatrixMetadata','Required parameter requestParameters.retoolingMatrixMetadata was null or undefined when calling putGraphneInternalRetoolingMatrixMetadataRetoolingmatrixid.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/internal/retooling-matrix/metadata/{retoolingMatrixId}`.replace(`{${"retoolingMatrixId"}}`, encodeURIComponent(String(requestParameters.retoolingMatrixId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.retoolingMatrixMetadata,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Replaces a retooling matrix\'s metadata (queue links and description) in full
     */
    async putGraphneInternalRetoolingMatrixMetadataRetoolingmatrixid(requestParameters: PutGraphneInternalRetoolingMatrixMetadataRetoolingmatrixidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RetoolingMatrixMetadata> {
        const response = await this.putGraphneInternalRetoolingMatrixMetadataRetoolingmatrixidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Replaces a retooling matrix\'s entries for a single \'from\' value with the given \'to\' values and setup times. To mean \'no value for this parameter\', send null or omit the field - a blank string is treated as a regular value and rejected unless the production parameter declares it.
     */
    async putGraphneInternalRetoolingMatrixRetoolingmatrixidEntriesRaw(requestParameters: PutGraphneInternalRetoolingMatrixRetoolingmatrixidEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.retoolingMatrixId === null || requestParameters.retoolingMatrixId === undefined) {
            throw new runtime.RequiredError('retoolingMatrixId','Required parameter requestParameters.retoolingMatrixId was null or undefined when calling putGraphneInternalRetoolingMatrixRetoolingmatrixidEntries.');
        }

        if (requestParameters.retoolingMatrixEntriesUpdate === null || requestParameters.retoolingMatrixEntriesUpdate === undefined) {
            throw new runtime.RequiredError('retoolingMatrixEntriesUpdate','Required parameter requestParameters.retoolingMatrixEntriesUpdate was null or undefined when calling putGraphneInternalRetoolingMatrixRetoolingmatrixidEntries.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/internal/retooling-matrix/{retoolingMatrixId}/entries`.replace(`{${"retoolingMatrixId"}}`, encodeURIComponent(String(requestParameters.retoolingMatrixId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.retoolingMatrixEntriesUpdate,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Replaces a retooling matrix\'s entries for a single \'from\' value with the given \'to\' values and setup times. To mean \'no value for this parameter\', send null or omit the field - a blank string is treated as a regular value and rejected unless the production parameter declares it.
     */
    async putGraphneInternalRetoolingMatrixRetoolingmatrixidEntries(requestParameters: PutGraphneInternalRetoolingMatrixRetoolingmatrixidEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putGraphneInternalRetoolingMatrixRetoolingmatrixidEntriesRaw(requestParameters, initOverrides);
    }

    /**
     * Updates priority flag for all lots in the production order containing the given task
     */
    async putGraphneProductionOrdersTasksTaskidPriorityRaw(requestParameters: PutGraphneProductionOrdersTasksTaskidPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.taskId === null || requestParameters.taskId === undefined) {
            throw new runtime.RequiredError('taskId','Required parameter requestParameters.taskId was null or undefined when calling putGraphneProductionOrdersTasksTaskidPriority.');
        }

        if (requestParameters.productionOrderPriorityUpdate === null || requestParameters.productionOrderPriorityUpdate === undefined) {
            throw new runtime.RequiredError('productionOrderPriorityUpdate','Required parameter requestParameters.productionOrderPriorityUpdate was null or undefined when calling putGraphneProductionOrdersTasksTaskidPriority.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("httpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/graphne/production-orders/tasks/{taskId}/priority`.replace(`{${"taskId"}}`, encodeURIComponent(String(requestParameters.taskId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.productionOrderPriorityUpdate,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates priority flag for all lots in the production order containing the given task
     */
    async putGraphneProductionOrdersTasksTaskidPriority(requestParameters: PutGraphneProductionOrdersTasksTaskidPriorityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.putGraphneProductionOrdersTasksTaskidPriorityRaw(requestParameters, initOverrides);
    }

}
